import React from 'react';
import { ListItemButton, ListItemText, IconButton, Popover, Box } from '@mui/material';
import { SketchPicker } from 'react-color';
import { GetCssRgba, HexToRgb, RgbToHex } from '../../../utilities/colorUtilities';
import TooltipHelpButton from '../../buttons/TooltipHelpButton/TooltipHelpButton';
import AddIcon from '@mui/icons-material/AddRounded';
import ArrowIcon from '@mui/icons-material/ArrowForwardRounded';
import ClearIcon from '@mui/icons-material/ClearRounded';

class ColorPickerListItem extends React.Component {
    state = {
        popoverOpen: false,
        anchorEl: null,
        secondaryPopoverOpen: false,
        secondaryAnchorEl: null,
        secondaryToggleButtonFocused: false
    }

    render() {
        const { text, color, onChange, disableAlpha, toolTip, disabled, allowSecondary, secondaryColor, onSecondaryChange, disableSecondaryButton } = this.props
        const { popoverOpen, anchorEl, secondaryToggleButtonFocused, secondaryPopoverOpen, secondaryAnchorEl } = this.state;

        let iconColor = color;
        if (typeof(color) === 'string') iconColor = HexToRgb(iconColor);
        let secondaryIconColor = secondaryColor;
        if (typeof(secondaryIconColor) === 'string') secondaryIconColor = HexToRgb(secondaryIconColor);

        return (
            <>
                <ListItemButton
                    onClick={this.togglePopoverOpen}
                    selected={popoverOpen}
                    disabled={disabled}
                    component='li'
                >
                    <ListItemText>
                        {text}
                        {toolTip ? 
                            <TooltipHelpButton
                                title={toolTip}
                            /> : null
                        }
                    </ListItemText>
                    <Box>
                        <IconButton
                            style={{ background: GetCssRgba(iconColor), boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)' }}
                            onClick={this.togglePopoverOpen}
                            aria-label='Pick color'
                            size="large" 
                        />
                        {allowSecondary ?
                            <>
                                <IconButton 
                                    onClick={(event) => {
                                        event.stopPropagation();

                                        if (secondaryColor) {
                                            onSecondaryChange(null);
                                            return;
                                        }

                                        const duplicateColor = {
                                            hex: RgbToHex(color.r, color.g, color.b),
                                            rgb: {
                                                a: color.a
                                            }
                                        };
                                        onSecondaryChange(duplicateColor);
                                    }} 
                                    onMouseEnter={() => this.setState({ secondaryToggleButtonFocused: secondaryColor ? true : false })}
                                    onMouseLeave={() => this.setState({ secondaryToggleButtonFocused: false })}
                                    aria-label={secondaryColor ? 'Add secondary color' : 'Remove secondary color'}
                                    size='small'
                                    disabled={disableSecondaryButton}
                                >
                                    {!secondaryColor ? 
                                        <AddIcon /> : secondaryToggleButtonFocused ?
                                        <ClearIcon /> :
                                        <ArrowIcon />
                                    }
                                </IconButton>
                                {secondaryColor &&
                                    <IconButton
                                        style={{ background: GetCssRgba(secondaryIconColor), boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)' }}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            this.toggleSecondaryPopoverOpen(event);
                                        }}
                                        aria-label='Pick color'
                                        size="large"
                                    />
                                }
                            </>
                        : null}
                    </Box>
                </ListItemButton>
                <Popover
                    open={popoverOpen}
                    anchorEl={anchorEl}
                    onClose={this.togglePopoverOpen}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <SketchPicker
                        color={color}
                        onChangeComplete={onChange}
                        presetColors={[]}
                        disableAlpha={disableAlpha}
                    />
                </Popover>
                <Popover
                    open={secondaryPopoverOpen}
                    anchorEl={secondaryAnchorEl}
                    onClose={this.toggleSecondaryPopoverOpen}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <SketchPicker
                        color={secondaryColor}
                        onChangeComplete={onSecondaryChange}
                        presetColors={[]}
                        disableAlpha={disableAlpha}
                    />
                </Popover>
            </>
        );
    }

    togglePopoverOpen = (event) => {
        const { popoverOpen } = this.state;

        this.setState({popoverOpen: !popoverOpen, anchorEl: event.currentTarget});
    }

    toggleSecondaryPopoverOpen = (event) => {
        const { secondaryPopoverOpen } = this.state;

        this.setState({secondaryPopoverOpen: !secondaryPopoverOpen, secondaryAnchorEl: event.currentTarget});
    }
}

export default ColorPickerListItem;